import Comment from 'antd/lib/comment'

import 'antd/lib/comment/style'

export * from 'antd/lib/comment'

export default Comment
